import axios from "axios";

axios.defaults.withCredentials = true;

const readAxiosInstance = axios.create({
  baseURL: "https://backend.stargames.co.ke/api/",
  //baseURL: "http://localhost:12300/api/",
});

const writeAxiosInstance = axios.create({
  //baseURL: "https://fun.db.ibibe.africa/api/",
  //baseURL: "http://localhost:12300/api/",
  baseURL: "https://backend.stargames.co.ke/api/",

});

const axiosInstances = {
  read: readAxiosInstance,
  write: writeAxiosInstance,
};

export default axiosInstances;